export default __webpack_public_path__ + "static/day-out-09e9575e98eb9432c4f310799ebe8c09.jpg";